import { select } from 'redux-saga/effects';
import { createReporterPayload } from 'ctm-util-functions';
import { transactionPayloadSelector } from 'ctm-selectors';

import * as api from '../api';

/**
 * Generator to log errors using the reporter.
 * @param {Object} action         - The action details.
 * @param {Object|String} report  - The report details.
 * @param {String} level          - Level of the console: [INFO, DEBUG, WARN, ERROR]
 */
export const reporterLog = function* (action = {}, report, level = null) {
    const transactionPayload = yield select(transactionPayloadSelector);
    const accountId = transactionPayload ? transactionPayload.get('accountId') : null;
    const journeyId = transactionPayload ? transactionPayload.get('journeyId') : null;
    const data = createReporterPayload(report, action.type, action.verticalStateKey, accountId, journeyId, level);

    // Make an asynchronous request to the reporter.
    api.postReporter(data);
};
